module.exports = __webpack_public_path__ + "static/media/successOnboardOLD.88a1afb9.svg";